module.exports = __webpack_public_path__ + "static/media/STAF_bokmål med tjenesteløfte_sentrert logo_pos(svart).40f36ed9.png";